import { ACTION_TYPE_SET_COVER_PRESENT, ACTION_TYPE_SET_LIGHT_NAV } from './actions';

const initialState = {
  coverPresent: 'no',
  lightNav: false,
};

function rootReducer(state = initialState, action) {
  if(action.type === ACTION_TYPE_SET_COVER_PRESENT){
    return Object.assign({}, state, {
      coverPresent: action.payload
    });
  }
  if(action.type === ACTION_TYPE_SET_LIGHT_NAV){
    return Object.assign({}, state, {
      lightNav: action.payload
    });
  }
  return state;
};

export default rootReducer;
